<script>
	import { navigate } from "svelte-routing";
	import Textfield from "@smui/textfield";
	import { Icon } from "@smui/common";
	import Button, { Label } from "@smui/button";
	import Card, { Content } from "@smui/card";

	import api from "../api";
	import { loggedin, user, routesById } from "../stores";

	// if not logged in, reroute to login
	$: if ($loggedin) {
		navigate($routesById.projects.path);
	}

	const errorText = "Wrong username or password.";

	let username = "";
	let password = "";

	let showPassword = false;
	let error = null;

	const login = async () => {
		try {
			await api.login(username, password);
		} catch (err) {
			error = err;
		}
	};
</script>

<div class="login">
	{#if !$loggedin}
		<Card>
			<div class="input">
				<Textfield bind:value={username} required type="username">
					<svelte:fragment slot="label">
						<Icon class="material-icons" style="font-size: 1em; line-height: normal; vertical-align: top;">person</Icon>
						Username
					</svelte:fragment>
				</Textfield>
				<Textfield
					bind:value={password}
					required
					type={showPassword ? "text" : "password"}
					on:keypress={(e) => {
						if (e.key === "Enter") {
							e.preventDefault();
							login();
						}
					}}
				>
					<svelte:fragment slot="label">
						<Icon class="material-icons" style="font-size: 1em; line-height: normal; vertical-align: top;">key</Icon> Password
					</svelte:fragment>
					<Icon
						on:click={() => (showPassword = !showPassword)}
						class="material-icons"
						slot="trailingIcon"
						style="font-size: 1em; line-height: normal; vertical-align: top;"
						>{showPassword ? "visibility_off" : "visibility"}</Icon
					>
				</Textfield>
			</div>
			<Button on:click={() => login()} style="width: 200px">
				<Label>Login</Label>
			</Button>
		</Card>
		{#if error}
			<p class="error">{errorText}</p>
		{/if}
	{/if}
</div>

<style lang="scss">
	.login {
		max-width: 400px;
		margin: 50px auto 0 auto;
		text-align: center;

		:global(.mdc-card) {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 20px;
			width: 100%;
		}
	}

	.error {
		color: $error;
	}

	.input {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
	}
</style>
